/**
 * 世界时钟(方案 A2.5 / B2):世界时间 = 北京时间实时映射。
 * 提供 0~24 的浮点小时;调试面板可覆盖以扫描全天。
 * dt 由 Pixi ticker 提供,这里只做时钟与全局风向等世界级量。
 */

let _debugHour: number | null = null;

/** 真·北京时间(UTC+8)的浮点小时,不受本机时区影响 */
function beijingHour(): number {
  const now = new Date();
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
  const bj = new Date(utcMs + 8 * 3600000);
  return bj.getHours() + bj.getMinutes() / 60 + bj.getSeconds() / 3600;
}

export const clock = {
  hour(): number {
    return _debugHour != null ? _debugHour : beijingHour();
  },
  setDebugHour(h: number | null) {
    _debugHour = h == null ? null : ((h % 24) + 24) % 24;
  },
  isDebug(): boolean {
    return _debugHour != null;
  },
};

/** 全局风向(方案 D3:风修饰一切)。x 分量,px/s(逻辑分辨率下)。 */
export const world = {
  wind: { x: 0, target: 0 },
  /** 每帧缓动风向 */
  updateWind(dt: number) {
    this.wind.x += (this.wind.target - this.wind.x) * Math.min(1, dt * 0.6);
  },
  setWind(target: number) {
    this.wind.target = target;
  },
};
